/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ShieldHalvedIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M21.499 32.298c8.249-4.706 10.436-13.992 10.499-19.514 0-.313-.25-.627-.563-.815L21.5 7.765zM32.56 9.208c1.375.627 2.437 1.945 2.437 3.576-.062 6.275-2.624 17.632-13.373 22.84a3.83 3.83 0 0 1-3.313 0c-10.749-5.208-13.31-16.565-13.31-22.84-.063-1.631.999-2.949 2.374-3.576l11.749-5.02a1.99 1.99 0 0 1 1.687 0z"/>}
        </IconWrapper>);
}
